import React from "react"
import Dropdown from "../../../components/Dropdown/Dropdown"
import { FILTER_CONTROL } from "./filterControlClass"

/**
 * ContactGroupFilter component for selecting contact group to filter by
 * @param {string} selectedGroup - Currently selected contact group ID
 * @param {function} setSelectedGroup - Setter for selected contact group
 * @param {array} contactGroups - List of contact groups { value, label }
 * @param {boolean} loading - Loading state
 */
const ContactGroupFilter = ({ selectedGroup, setSelectedGroup, contactGroups = [], loading = false }) => {
  const menuItems = [
    { value: '', label: 'All Groups' },
    ...contactGroups
  ]

  return (
    <Dropdown
      value={selectedGroup}
      setValue={setSelectedGroup}
      menuItems={menuItems}
      placeholder="Select group"
      ariaLabel="Filter by contact group"
      className={`w-[200px] ${FILTER_CONTROL}`}
    />
  )
}

export default ContactGroupFilter
